import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject  } from 'rxjs';
import { INotifications } from '../../../../models/notifications.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import { environment } from '../../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  unreadNotificationCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  constructor(private httpClient: HttpClient) {}

  getAllNotifications(): Observable<ISibasiHTTPResponse<INotifications[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/user/all`
    );
  }
  getUnreadNotifications(): Observable<ISibasiHTTPResponse<INotifications[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/user/unread`
    );
  }
  getNotificationsCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.get<ISibasiHTTPResponse<number>>(
      `${environment.api_url}/notification/user/unread/count`
    ).pipe(
      map(res => {
        this.unreadNotificationCount.next(res.result);
        return res;
      })
    );
  }

  adminGetAllNotifications(): Observable<
    ISibasiHTTPResponse<INotifications[]>
  > {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/admin/all`
    );
  }
  adminGetUnreadNotifications(): Observable<
    ISibasiHTTPResponse<INotifications[]>
  > {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/admin/unread`
    );
  }
  readNotification(
    notificationId: string
  ): Observable<ISibasiHTTPResponse<INotifications[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/read/${notificationId}`
    );
  }
  markAllRead(): Observable<ISibasiHTTPResponse<INotifications[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotifications[]>>(
      `${environment.api_url}/notification/markRead/all`
    );
  }
  deleteNotification(
    notificationId: string
  ): Observable<ISibasiHTTPResponse<INotifications>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INotifications>>(
      `${environment.api_url}/notification/delete/${notificationId}`
    );
  }
}
